import { useEffect } from "react";
import { useLocation } from "react-router";

import { EventName } from "@motain/web-shared-hub/features";
import { sendTrackingEventWithSysProps } from "@features/tracking/sendTrackingEventWithSysProps";

export function usePageTracking(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    void sendTrackingEventWithSysProps({
      name: EventName.PageView,
      properties: {},
    });
  }, [pathname]);
}
